export default "__VITE_ASSET__Vp_4c2hZ__"